import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@ex/module/core/domain/base-component';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class TablePaginatorComponent extends BaseComponent {
  @Input() pageSize: number = 10;
  @Input() language: string = 'EN';
  @Input() totalRecords: number = 0;

  @Input('page') set page(page: number) {
    this.pageIndex = page;
  }
  @Output() pageChanged = new EventEmitter<number>();

  @Input() showPageSizeOptions: boolean = false;
  @Output() pageSizeChanged = new EventEmitter<number>();

   pageSizeOptions = [
    { key: 5, name: '5' },
    { key: 10, name: '10' },
    { key: 20, name: '20' },
    { key: 25, name: '25' },
    { key: 50, name: '50' },
    { key: 100, name: '100' }
  ];

  @Input('pageSizeOptions') set _pageSizeOptions(options: any[]){
    if(options.length>0){
      this.pageSizeOptions=options;
    }
  }

  onPageSizeChange(newPageSize: any) {
    if (newPageSize?.key) newPageSize = newPageSize.key;
    this.pageSize = newPageSize;
    this.pageSizeChanged.emit(newPageSize);
  }

  pageIndex: number = 0;
  pageNumbers!: [];

  goToChange(number: number) {
    this.pageIndex = number;
    this.pageChanged.emit(number);
  }

  get totalPages() {
    if (this.totalRecords == 0)
      return [];

    const pages = Math.ceil(this.totalRecords / this.pageSize);
    if (!pages)
      return []
    return Array(pages).fill(4).map((x, i) => i + 1);
  }


}